import { useEffect, useState } from "react";
import Shell from "../components/Shell";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Mail, Trash2, X } from "lucide-react";

export default function AdminTeam() {
  const [agents, setAgents] = useState([]);
  const [showInvite, setShowInvite] = useState(false);
  const [inv, setInv] = useState({ email: "", full_name: "" });

  const load = async () => {
    try { const { data } = await api.get("/admin/agents"); setAgents(data); }
    catch { toast.error("Admin access required"); }
  };
  useEffect(() => { load(); }, []);

  const invite = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/admin/invite", inv);
      toast.success(data.email_sent ? `Invite sent to ${inv.email}` : "Invite created");
      setShowInvite(false); setInv({ email: "", full_name: "" }); load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
  };

  const removeAgent = async (a) => {
    if (!window.confirm(`Remove ${a.full_name} and all their data?`)) return;
    try { await api.delete(`/admin/agents/${a.id}`); toast.success("Removed"); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <Shell>
      <div className="p-4 sm:p-8" data-testid="admin-team-page">
        <div className="flex items-end justify-between flex-wrap gap-3 mb-6">
          <div>
            <div className="label-xs text-amber">&gt; ADMIN / TEAM</div>
            <h1 className="font-display text-3xl sm:text-5xl leading-none mt-2">Agency.</h1>
            <p className="mt-2 text-fg-muted font-mono text-sm">{agents.length} AGENTS</p>
          </div>
          <button onClick={() => setShowInvite(true)} className="btn-primary" data-testid="invite-agent-btn">
            <Mail size={14} /> Invite Agent
          </button>
        </div>

        <div className="border border-term bg-raised overflow-x-auto">
          <div className="min-w-[720px]">
          <div className="grid grid-cols-[2fr,1fr,1fr,1fr,1fr,1fr,60px] gap-2 px-4 py-3 border-b border-term label-xs">
            <div>AGENT</div><div className="text-right">LEADS</div><div className="text-right">DIALS</div><div className="text-right">CLOSES</div><div className="text-right">COMM</div><div className="text-right">ONBOARD</div><div></div>
          </div>
          {agents.length === 0 && <div className="p-6 text-xs text-fg-muted font-mono">No agents yet. Invite your first.</div>}
          {agents.map((a) => (
            <div key={a.id} className="tap-row grid grid-cols-[2fr,1fr,1fr,1fr,1fr,1fr,60px] gap-2 px-4 py-3 text-xs font-mono items-center" data-testid={`agent-row-${a.id}`}>
              <div>
                <div className="text-fg font-bold">{a.full_name}</div>
                <div className="text-fg-subtle text-[10px]">{a.email}</div>
              </div>
              <div className="text-right text-fg-muted">{a.kpis.total_leads}</div>
              <div className="text-right text-fg-muted">{a.kpis.total_dials}</div>
              <div className="text-right text-gain">{a.kpis.closed_won}</div>
              <div className="text-right text-amber">${Math.round(a.kpis.commission_earned).toLocaleString()}</div>
              <div className="text-right">
                <div className="text-fg-muted">{a.kpis.onboarding_pct}%</div>
                <div className="w-full h-0.5 bg-muted mt-1">
                  <div className="h-full bg-amber" style={{ width: `${a.kpis.onboarding_pct}%` }} />
                </div>
              </div>
              <button onClick={() => removeAgent(a)} className="text-fg-subtle hover:text-live justify-self-end" data-testid={`remove-agent-${a.id}`}><Trash2 size={12} /></button>
            </div>
          ))}
          </div>
        </div>

        {showInvite && (
          <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" onClick={() => setShowInvite(false)}>
            <form onClick={(e) => e.stopPropagation()} onSubmit={invite} className="bg-raised border border-term p-6 max-w-md w-full">
              <div className="flex justify-between items-center mb-5">
                <div>
                  <div className="label-xs text-amber">&gt; INVITE</div>
                  <div className="font-display text-2xl mt-1">New Agent</div>
                </div>
                <button type="button" onClick={() => setShowInvite(false)} className="text-fg-muted"><X size={18} /></button>
              </div>
              <div className="space-y-3">
                <input required placeholder="Full Name" className="input-term" value={inv.full_name} onChange={(e) => setInv({ ...inv, full_name: e.target.value })} data-testid="invite-name-input" />
                <input required type="email" placeholder="Email" className="input-term" value={inv.email} onChange={(e) => setInv({ ...inv, email: e.target.value })} data-testid="invite-email-input" />
                <p className="text-[10px] text-fg-muted font-mono uppercase tracking-widest">WE&apos;LL EMAIL A SIGNUP LINK. THEY SET THEIR OWN PIN.</p>
              </div>
              <button type="submit" className="btn-primary mt-5 w-full" data-testid="invite-submit-btn">Send Invite &gt;</button>
            </form>
          </div>
        )}
      </div>
    </Shell>
  );
}
